import { useNavigate } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center p-6 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-20 -left-20 w-96 h-96 bg-purple-600 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-blob"></div>
      <div className="absolute bottom-20 -right-20 w-96 h-96 bg-blue-600 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-blob animation-delay-2000"></div>

      <div className="text-center space-y-8 relative z-10 max-w-lg">
        {/* 404 Gigante */}
        <div className="relative">
          <div className="text-9xl font-extrabold text-white/5 select-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-6xl animate-bounce">🦁❓</div>
          </div>
        </div>

        <div className="space-y-4">
          <h1 className="text-3xl md:text-4xl font-bold">
            Ops! Página não encontrada
          </h1>
          <p className="text-slate-400 text-lg">
            Parece que você explorou um território desconhecido. Essa página não
            existe ou foi movida.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 border border-white/10 rounded-full hover:bg-white/5 transition-all flex items-center justify-center gap-2 text-slate-300"
          >
            <ArrowLeft size={20} />
            Voltar
          </button>

          <button
            onClick={() => navigate("/")}
            className="px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full hover:shadow-lg hover:shadow-purple-500/50 transition-all flex items-center justify-center gap-2 font-semibold"
          >
            <Home size={20} />
            Ir para o Início
          </button>
        </div>
      </div>
    </div>
  );
}
